import React, { memo, useState, useMemo } from 'react';
import { createUseStyles, Icon, useTheme, Tooltip } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotClearButton');

const ClearButton = memo(({ onClick }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useWeb5Context();
    const [isOver, setIsOver] = useState(false);

    const displayClear = useMemo(() => {
        if (isOver && !!onClick) return true;
        return false;
    }, [isOver, onClick]);

    const displayClearOutline = useMemo(() => {
        if (!displayClear || !onClick) return true;
        return false;
    }, [displayClear, onClick]);

    return (
        <Tooltip placement="top" content={t('action_clear')}>
            <div
                className={classnames(classes.root, {
                    [classes.clearDisabled]: !onClick,
                })}
                onClick={onClick || null}
                onMouseOver={() => setIsOver(true)}
                onMouseOut={() => setIsOver(false)}
            >
                {displayClearOutline && (
                    <Icon
                        name="clearOutline"
                        size="large"
                        color={
                            onClick ? theme.colors.actionMajor[500] : theme.colors.actionMinor[500]
                        }
                    />
                )}
                {displayClear && (
                    <Icon
                        name="clear"
                        size="large"
                        color={
                            onClick ? theme.colors.actionMajor[500] : theme.colors.actionMinor[500]
                        }
                    />
                )}
            </div>
        </Tooltip>
    );
});

export default ClearButton;
